
import { v4 as uuidv4 } from 'uuid';
import { Industry } from '@/types/assessment';
import { AnalyticsInsight } from '@/types/assessment/analytics';

/**
 * Generates insights based on assessment data
 */
export const generateInsights = (
  dimensionScores: Record<string, number>,
  industry: Industry
): AnalyticsInsight[] => {
  return [
    {
      id: uuidv4(),
      title: "Focus on Data Governance",
      description: `Based on your ${dimensionScores["data"]?.toFixed(1) || "3.0"} score in Data, implementing a formal data governance framework would significantly improve your AI capabilities.`,
      dimension: "data",
      timestamp: new Date().toISOString(),
      priority: "high"
    },
    {
      id: uuidv4(),
      title: "Technical Debt Warning",
      description: `Organizations in the ${industry} sector with similar scores often face increasing technical debt. Consider a technical debt reduction plan.`,
      timestamp: new Date().toISOString(),
      priority: "medium"
    },
    {
      id: uuidv4(),
      title: "Talent Development Opportunity",
      description: `Your talent score of ${dimensionScores["talent"]?.toFixed(1) || "3.0"} indicates an opportunity to implement AI skills training programs.`,
      dimension: "talent",
      timestamp: new Date().toISOString(),
      priority: "high"
    },
    {
      id: uuidv4(),
      title: "Strategy Alignment",
      description: `Your strategy score (${dimensionScores["strategy"]?.toFixed(1) || "3.0"}) suggests the need for stronger alignment between AI initiatives and business goals.`,
      dimension: "strategy",
      timestamp: new Date().toISOString(),
      priority: "medium"
    },
    {
      id: uuidv4(),
      title: "Deployment Process Improvement",
      description: `Consider implementing a more structured MLOps process to improve your deployment score of ${dimensionScores["deployment"]?.toFixed(1) || "3.0"}.`,
      dimension: "deployment",
      timestamp: new Date().toISOString(),
      priority: "low"
    }
  ];
};
